
import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';

const LISTADO = 'LISTADO';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const PARAMETRO = 'PARAMETRO';
const DETALLE = 'DETALLE';
const DETALLE_ORDEN = 'DETALLE_ORDEN';
const CLIENTE = 'CLIENTE';
const TIPO_CAMBIO = 'TIPO_CAMBIO';
const TIPO = 'TIPO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});


export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    
    const params = { id };
    dispatch(setLoader(true));
    api.get('/presupuesto', params).then((response) => {
        dispatch({ type: LISTADO, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar presupuestos',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id }
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({ type: PARAMETRO, datos: response });
    }).catch((error) => {

        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}


export const listarProyectos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/orden_servicio/proyectos',params).then(data=>{
        const list_proyectos = [];
        if(data){
            data.forEach(item=>{
                list_proyectos.push({
                    value: item.id,
                    label: 'IOS' + ' -- ' + item.numero + ' / ' + item.nombre_proyecto
                })
            })
        }
        return list_proyectos;
    }).catch((error)=>{
        
        return [];
    })
}


let detalle = [];
export const agregarLinea = (tipoCambio) => (dispatch, getStore) => {
    const data = getStore().form.FormPresupuesto.values;
    if (tipoCambio === 0 || tipoCambio === 0.000000) {
        Swal.fire({
            title: 'Presupuesto',
            text: 'Debe de ingresar tipo de cambio',
            type: 'error',
        })
    }else{
        if (data === undefined || data === null) {
            Swal.fire({
                title: 'Presupuesto',
                text: 'Debe de selecionar una linea presupuestaria',
                type: 'error',
            })
        } else {
            if (data.linea === undefined || data.linea === null) {
                Swal.fire({
                    title: 'Presupuesto',
                    text: 'Debe de selecionar una linea presupuestaria',
                    type: 'error',
                })
            } else {
                if (data.monto_q === undefined || (parseFloat(data.monto_q) !== 0 && parseFloat(data.monto_q) < 5.00)) {
                    Swal.fire({
                        title: 'Presupuesto',
                        text: 'Debe de ingresar monto mayor de 5.00 quetzales o monto igual a 0.00',
                        type: 'error',
                    })
                }else{
                    let linea = data.linea.value.split("#");
                    if (detalle.length > 0) {
                        const dato = detalle.find(item => item.id === linea[0].trim());
                        if (dato) {
                            NotificationManager.error(
                                'Linea presupuestaria ya fue ingresada',
                                'Error',
                                3000
                            );
                        } else {
                            detalle.push({
                                id: linea[0].trim(),
                                linea: linea[1].trim(),
                                idLinea: linea[0].trim(),
                                totalQ: data.monto_q,
                                totalD: data.monto_q !== 0 ? parseFloat(parseFloat(data.monto_q) / parseFloat(tipoCambio)).toFixed(2) : 0.00,
                            })
                            data.total = 0.00;
                            data.detalleD = detalle;
                            NotificationManager.success(
                                'Linea presupuestaria ingresada correctamente',
                                'Exito',
                                3000
                            );
                            dispatch(actualizar());
                        }
                    } else {
                        detalle.push({
                            id: linea[0].trim(),
                            linea: linea[1].trim(),
                            idLinea: linea[0].trim(),
                            totalQ: data.monto_q,
                            totalD: parseFloat(parseFloat(data.monto_q) / parseFloat(tipoCambio)).toFixed(2),
                        })
                        data.monto_q = 0.00;
                        data.detalleD = detalle;
                        NotificationManager.success(
                            'Linea presupuestaria ingresada correctamente',
                            'Exito',
                            3000
                        );
                        dispatch(actualizar());
                    }
                }
            }
        }
    }
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormPresupuesto.values;
    dispatch(initializeForm('FormPresupuesto', data));
    dispatch({ type: DETALLE, detalleOrden: data.detalleD })
};

const limpiarPresupuesto = () => (dispatch) => {
    detalle = [];
    dispatch({ type: DETALLE, detalleOrden: detalle })
    dispatch({type: TIPO, tipoProyecto: ''})
};


export const registroPresupuesto = (detalleO, tipoCambio) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormPresupuesto.values;
    if (data.proyecto === undefined || data.proyecto === null) {
        Swal.fire({
            title: 'Presupuesto',
            text: 'Debe de seleccionar un proyecto',
            type: 'error',
        })
    } else {
        if (detalleO.length === 0) {
            Swal.fire({
                title: 'Presupuesto',
                text: 'Debe de ingresar detalle de presupuesto',
                type: 'error',
                })
        } else {
            const formData = {
                proyecto: data.proyecto.value,
                tipo_cambio: tipoCambio,
                imprevistos: data.imprevistos ? data.imprevistos: 0.00,
                inflacion: data.inflacion ? data.inflacion: 0.00,
                utilidad: data.utilidad ? data.utilidad: 0.00,
                comision: data.comision ? data.comision: 0.00,
                renta: data.renta ? data.renta: 0.00,
                retencion: data.retencion ? data.retencion: 0.00,
                observaciones: data.observaciones,
                detallePresupuesto: data.detalleD,
                empresa: id_emp[5],
            }
            dispatch(setLoader(true));
            api.post('/presupuesto/', formData).then(() => {
                NotificationManager.success(
                    'Presupuesto guardado correctamente',
                    'Exito',
                    3000
                );
                let ruta = `/gestion_proyecto/${id_emp[5]}/presupuesto`;
                dispatch(push(ruta));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }
}

const leerDetallePresupuesto = id => (dispatch) => {
    api.get(`/presupuesto_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_ORDEN, detalleOrd: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/presupuesto/${id}`).then((response) => {
        dispatch(leerDetallePresupuesto(response.id));
        dispatch({type: TIPO_CAMBIO, cambioD: response.tipo_cambio})
        dispatch({type: TIPO, tipoProyecto: response.tipo_proyecto})
        dispatch(initializeForm('FormPresupuesto', response));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar presupuesto',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormPresupuesto.values;
    
    detalle.forEach((element, index) => {
        if (element.id === id) {
            detalle.splice(index, 1);
        }
    })
    data.detalleD = detalle;
    dispatch(actualizar());
};

export const listarLineas = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/linea_presupuestaria/lineas',params).then(data=>{
        const list_lineas = [];
        if(data){
            data.forEach(item=>{
                list_lineas.push({
                    value: item.id + '#' + item.descripcion,
                    label: item.descripcion
                })
            })
        }
        return list_lineas ;
    }).catch((error)=>{
        return [];
    })
}

export const agregarLineaNueva = (tipoCambio) => (dispatch, getStore) => {
    const data = getStore().form.FormPresupuesto.values;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    if (tipoCambio === 0 || tipoCambio === 0.000000) {
        Swal.fire({
            title: 'Presupuesto',
            text: 'Debe de ingresar tipo de cambio',
            type: 'error',
        })
    }else{
        if (data.linea === undefined || data.linea === null) {
            Swal.fire({
                title: 'Presupuesto',
                text: 'Debe de seleccionar linea presupuestaria',
                type: 'error',
            })
        } else {
            if (data.monto_q === undefined || data.monto_q === 0.00) {
                Swal.fire({
                    title: 'Presupuesto',
                    text: 'Debe de ingresar monto en quetzales',
                    type: 'error',
                })
            } else {
                let linea = data.linea.value.split("#");
                const formData = {
                    totalQ: data.monto_q,
                    totalD: parseFloat(parseFloat(data.monto_q) / parseFloat(tipoCambio)).toFixed(2),
                    idLinea: linea[0].trim(),
                    id: id_emp[7],
                }
                dispatch(setLoader(true));
                api.post('/presupuesto_detalle/', formData).then((response) => {
                    dispatch(leerDetallePresupuesto(response.id));
                    NotificationManager.success(
                        'Linea presupuestaria correctamente',
                        'Exito',
                        3000
                    );
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        0
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
}

export const modificarPresupuesto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormPresupuesto.values;
    let id = id_emp[7]
    let proyecto= data.proyecto_mod;
    if (proyecto === undefined){
        proyecto = data.proyecto;
    }else{
        proyecto = data.proyecto_mod.value;
    }
    const formData = {
        id: id,
        proyecto: proyecto,
        observaciones: data.observaciones,
        imprevistos: data.porcentaje_imprevistos,
        inflacion: data.porcentaje_inflacion,
        utilidad: data.porcentaje_utilidad,
        comision: data.porcentaje_comision_ventas,
        renta: data.porcentaje_renta,
        retencion: data.porcentaje_retencion,
    }
    dispatch(setLoader(true));
    api.put(`/presupuesto/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Presupuesto modificado correctamente',
            'Exito',
            3000
        );

        let ruta = `/gestion_proyecto/${id_emp[5]}/presupuesto`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarLineaGasto = id => (dispatch) => {
    let ruta = window.location.href.split('/');
    let id_emp = ruta[7];
    dispatch(setLoader(true));
    api.eliminar(`/presupuesto_detalle/${id}`).then(() => {
        dispatch(leerDetallePresupuesto(id_emp));
        NotificationManager.success(
            'Linea presupuestaria borrada correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const buscarCliente = (id) => (dispatch) => {
    api.get(`/orden_servicio/${id}`).then((response) => {
        dispatch({type: CLIENTE, clienteProyecto: response.clienteN})
        dispatch({type: TIPO, tipoProyecto: response.tipo})
    }).catch(() => {
        return [];
    })
}

export const imprimirPresupuesto = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id_empresa = id_emp[5];
    let id_presupuesto = id
    let reporte = 'imprimir_presupuesto';
    const params = { id_empresa, reporte, id_presupuesto };
    dispatch(setLoader(true));
    api.getPdf('/presupuesto/', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'presupuesto.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al generar reporte',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarPresupuesto = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/presupuesto/${id}`).then(() => {
        dispatch(listar(1));
        NotificationManager.success(
            'Presupuesto borrado correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar preuspuesto',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroPresupuesto,
    modificarPresupuesto,
    leer,
    limpiarPresupuesto,
    listarLineas,
    listarProyectos,
    getModulo,
    parametrosEmpresa,
    agregarLinea,
    eliminarLineaGasto,
    agregarLineaNueva,
    eliminarLinea,
    buscarCliente,
    imprimirPresupuesto,
    eliminarPresupuesto
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [DETALLE]: (state, { detalleOrden }) => {
        return {
            ...state,
            detalleOrden,
        };
    },
    [DETALLE_ORDEN]: (state, { detalleOrd }) => {
        return {
            ...state,
            detalleOrd,
        };
    },
    [CLIENTE]: (state, { clienteProyecto }) => {
        return {
            ...state,
            clienteProyecto,
        };
    },
    [TIPO_CAMBIO]: (state, { cambioD }) => {
        return {
            ...state,
            cambioD,
        };
    },
    [TIPO]: (state, { tipoProyecto }) => {
        return {
            ...state,
            tipoProyecto,
        };
    },
};

export const initialState = {
    loader: false,
    tipos: [],
    periodoS: null,
    monedas: [],
    modulo: [],
    data: [],
    detalleOrden: [],
    detalleOrd: [],
    clienteProyecto: '',
    cambioD: 0.000000,
    tipoProyecto: ''
};

export default handleActions(reducers, initialState)